import React, { useMemo } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { Requester, Price } from 'models/travelDetails';
import { getFormattedPrice } from 'utils/currency';

import { Row } from '../styles';
import { Value, Text, TravelerName, TravelerGroup, Container, GuestIcon, GroupIcon } from './styles';

type Props = {
  requester: Requester;
  price: Price;
  adminView?: boolean;
};

const RequesterInfo = ({ requester, price, adminView }: Props) => {
  const { t } = useStoreTranslation();
  const { fullName, eticket, locator } = requester;
  const { currencyCode, total } = price;

  const formattedValue = useMemo(() => {
    const formattedPrice = (value: number | undefined) => getFormattedPrice({ value, currency: currencyCode, t });
    return formattedPrice(total);
  }, [currencyCode, t, total]);

  return (
    <Container>
      {adminView ? (
        <>
          <Row>
            <TravelerName>{fullName}</TravelerName>
            <Value>
              <b>{formattedValue?.formattedWithoutCode}</b> {formattedValue?.currency}
            </Value>
          </Row>
          <Row>
            <TravelerGroup $adminView>
              {requester.isGuest ? (
                <>
                  <GuestIcon color="currentColor" height={16} />
                  {t('requestCard.invited')}
                </>
              ) : (
                <>
                  <GroupIcon color="currentColor" height={16} />
                  {requester.sector}
                </>
              )}
            </TravelerGroup>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <div>
              {locator && (
                <Text>
                  {t('tripCard.reserveNumber')}: {locator}
                </Text>
              )}
              {eticket && (
                <Text>
                  {t('tripCard.eticket')}: {eticket}
                </Text>
              )}
            </div>
          </Row>
          <Row>
            <TravelerName>{fullName}</TravelerName>
            <TravelerGroup>
              {requester.isGuest ? (
                <>
                  <GuestIcon color="currentColor" height={16} />
                  {t('requestCard.invited')}
                </>
              ) : (
                <>
                  <GroupIcon color="currentColor" height={16} />
                  {requester.sector}
                </>
              )}
            </TravelerGroup>
          </Row>
        </>
      )}
    </Container>
  );
};

export default RequesterInfo;
